import React, { useState } from 'react'
import { CreateCampaign } from '../Common/apis';
import { toast } from 'react-toastify';


const currencySymbols = {
    IDR: 'Rp',
    INR: '₹',
    USD: '$',
};


function CreateNewCampaign() {
    const [selectedCurrency, setSelectedCurrency] = useState('IDR');

    const [categories, setCategories] = useState([
        "Medical",
        "Education",
        "Environment",
        "Animal Welfare"
    ]);

    const [campaignCategories, setCampaignCategories] = useState([
        "Personal",
        "Community",
        "Charity"
    ]);

    const [selectedImages, setSelectedImages] = useState([]);
    const [imageFiles, setImageFiles] = useState([]);
    const [mainImage, setMainImage] = useState(null);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (imageFiles.length + files.length > 4) return;

        const filePreviews = files.map(file => URL.createObjectURL(file));

        setSelectedImages(prev => [...prev, ...filePreviews]);
        setImageFiles(prev => [...prev, ...files]);
        setMainImage(files[0]); // Set main image as File object
    };


    const [form, setForm] = useState({
        CampaignName: '',
        CampaignerName: '',
        CampaignerContact: '',
        Campaignstory: '',
        CampaignStartDate: '',
        CampaignEndDate: '',
        Category: '',
        CampaignCategory: '',
        TotalRequiredDonation: '',
    });


    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };


    const handleSubmit = async () => {
        const formdata = new FormData();

        // Append form fields from state
        for (let key in form) {
            formdata.append(key, form[key]);
        }

        if (imageFiles.length > 0) {
            // 👇 Append first file as main image
            formdata.append("Image", imageFiles[0]);

            // 👇 Append all files as multiple images
            imageFiles.forEach((file) => {
                formdata.append("Images", file);
            });
        }

        try {
            const res = await CreateCampaign(formdata);
            toast.success(res?.message);
            setForm({
                CampaignName: '',
                CampaignerName: '',
                CampaignerContact: '',
                Campaignstory: '',
                CampaignStartDate: '',
                CampaignEndDate: '',
                Category: '',
                CampaignCategory: '',
                TotalRequiredDonation: '',
            });
            setSelectedImages([]);
            setImageFiles([]);
        } catch (err) {
            toast.error(err?.message);
        }
    };


    return (
        <>
            <div className='mt-[80px]'>
                <div className='pt-[50px] md:px-[110px] px-[20px]'>
                    <h6 className="text-center max-w-[572px] w-full mx-auto text-heading-primary text-[#2D190D] pb-[50px]">Create New <span className='text-[#FF6000]'>Campaign</span></h6>
                    <div className="grid md:grid-cols-2 grid-cols-1 md:pb-[100px] pb-[30px] md:gap-[62px] gap-[30px] justify-center">
                        <div className='max-w-[603px] w-full mx-auto'>
                            {/* Main Image */}
                            <img src={mainImage} alt="Main" className='w-full rounded-[8px] object-cover' />

                            {/* Upload and Thumbnails */}
                            <div className='pt-[18px] flex flex-wrap gap-[18px]'>
                                {/* Upload label: only show if less than 4 images */}
                                {selectedImages.length < 4 && (
                                    <label
                                        htmlFor="file-upload"
                                        className='cursor-pointer border-dashed h-[110px] border-[2px] border-[#FF6000] rounded-[8px] max-w-[137px] w-full flex justify-center items-center flex-col gap-[4px]'
                                    >
                                        <img src="/assets/impact/plus-circle.svg" alt="upload icon" />
                                        <p className="text-center font-[400] text-[11px] font-manrope text-[#1A1B25]">
                                            Upload <br /> Photo
                                        </p>
                                        <input
                                            type="file"
                                            id="file-upload"
                                            className="hidden"
                                            onChange={handleFileChange}
                                            multiple
                                            accept="image/*"
                                        />
                                    </label>
                                )}

                                {/* Image thumbnails */}
                                {selectedImages.map((img, index) => (
                                    <img
                                        key={index}
                                        src={img}
                                        alt={`Uploaded ${index + 1}`}
                                        className="max-w-[137px] w-full h-[100px] object-cover rounded-[8px] cursor-pointer"
                                        onClick={() => setMainImage(img)}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className='max-w-[574px] w-full mx-auto'>
                            <h6 className="font-[700] font-manrope text-[24px] text-[#333333] pb-[30px]">Campaign details</h6>
                            <div className="flex flex-col gap-[20px]">
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Title</h6>
                                    <input type="text" name="CampaignName" value={form.CampaignName} onChange={handleChange} className='input-box w-full' placeholder='Enter title' />
                                </div>
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Campaigner Name</h6>
                                    <input type="text" name="CampaignerName" value={form.CampaignerName} onChange={handleChange} className='input-box w-full' placeholder='Enter Campaigner Name' />
                                </div>
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Campaign Story</h6>
                                    <input type="text" name="Campaignstory" value={form.Campaignstory} onChange={handleChange} className='input-box w-full' placeholder='Enter Campaign Story' />
                                </div>
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Campaign Contact</h6>
                                    <input type="text" name="CampaignerContact" value={form.CampaignerContact} onKeyDown={(e) => {
                                        if (
                                            ['e', 'E', '+', '-', '.'].includes(e.key)
                                        ) {
                                            e.preventDefault();
                                        }
                                    }}
                                        maxLength={10}
                                        onChange={handleChange} className='input-box w-full' placeholder='Enter Campaign Contact' />
                                </div>
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Campaigner Start Date</h6>
                                    <input type="date" name="CampaignStartDate" value={form.CampaignStartDate} onChange={handleChange} className='input-box w-full' placeholder='Enter Campaigner Start Date' />
                                </div>
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Campaigner End Date</h6>
                                    <input type="date" name="CampaignEndDate" value={form.CampaignEndDate} onChange={handleChange} className='input-box w-full' placeholder='Enter Campaigner End Date' />
                                </div>
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Category</h6>
                                    <select
                                        className='input-box w-full'
                                        name="Category"
                                        value={form.Category}
                                        onChange={(e) => setForm({ ...form, Category: e.target.value })}
                                    >
                                        <option value="">Select Category</option>
                                        {categories.map((cat, index) => (
                                            <option key={index} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Campaigner Category</h6>
                                    <select
                                        className='input-box w-full'
                                        name="CampaignCategory"
                                        value={form.CampaignCategory}
                                        onChange={(e) => setForm({ ...form, CampaignCategory: e.target.value })}
                                    >
                                        <option value="">Select Campaigner Category</option>
                                        {campaignCategories.map((cat, index) => (
                                            <option key={index} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <h6 className="font-[600] pb-[6px] font-manrope text-[16px] text-[#0D0D12]">Total donation required</h6>
                                    <div className='bg-[#F6F8FA] border border-[#DFE1E7] rounded-[16px] p-[12px] items-center grid grid-cols-2 gap-[12px]'>
                                        <select
                                            value={selectedCurrency}
                                            onChange={(e) => setSelectedCurrency(e.target.value)}
                                            className='border-none bg-transparent font-[700] font-manrope text-[16px] text-[#333333] focus:outline-none py-[7px] px-[4px]'
                                        >
                                            <option value="IDR">IDR</option>
                                            <option value="INR">INR</option>
                                            <option value="USD">USD</option>
                                        </select>
                                        <div className='relative w-full'>
                                            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[16px] text-[#333] font-bold">
                                                {currencySymbols[selectedCurrency]}
                                            </span>
                                            <input
                                                type="number"
                                                placeholder="Enter amount"
                                                value={form.TotalRequiredDonation}
                                                onChange={(e) =>
                                                    setForm({ ...form, TotalRequiredDonation: e.target.value })
                                                }
                                                className="w-full pl-10 font-[700] text-[16px] text-[#333] bg-transparent outline-none"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="pt-[8px] pb-[52px] font-[400] font-manrope text-[14px] text-[#666666]">The minimum donation is IDR15.000</p>
                            <div className='grid lg:grid-cols-2 grid-cols-1 gap-[8px]'>
                                <button className='uppercase flex justify-center items-center py-[14px] gap-[10px] border border-[#FF6000] rounded-[8px] font-[700] font-manrope text-[18px] text-[#FF6000]'> <img src="/assets/impact/bookmark-check.svg" alt="" />Draft</button>
                                <button onClick={handleSubmit} className='d-btn w-full text-center'>DONATE NOW</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateNewCampaign
